import { Avatar } from "components/DesignSystem/AvatarGroup/Avatar";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { ROLE_TAG_TYPE } from "components/ChannelinfoSlider/ChannelInfo/TeamMembers/TeamMembers";
import { MentionItem, MentionPopup } from "./createMentionSuggestion";
import { SuggestionListbox, SuggestionOption } from "./SuggestionListbox";

type MentionSuggestionListProps = {
  popup: MentionPopup;
};

type MentionOptionProps = {
  item: MentionItem;
  isHighlighted: boolean;
  onSelect: (item: MentionItem) => void;
  onHighlight: (item: MentionItem) => void;
};

const MentionOption = ({
  item,
  isHighlighted,
  onSelect,
  onHighlight,
}: MentionOptionProps) => {
  const handleSelect = () => onSelect(item);
  const handleHighlight = () => onHighlight(item);

  return (
    <SuggestionOption
      label={item.label}
      isHighlighted={isHighlighted}
      onSelect={handleSelect}
      onHighlight={handleHighlight}
    >
      <Avatar alt={item.label} src={item.image} size="extra-small" />
      <span className="t-flex-1 t-truncate">{item.label}</span>
      {item.roles.length > 0 && (
        <span className="t-flex t-shrink-0 t-gap-1">
          {item.roles.map((role) => (
            <Tag
              key={role}
              tagType={ROLE_TAG_TYPE[role] || "gray"}
              size="small"
              icon={false}
            >
              {role}
            </Tag>
          ))}
        </span>
      )}
    </SuggestionOption>
  );
};

export const MentionSuggestionList = ({
  popup,
}: MentionSuggestionListProps) => (
  <SuggestionListbox ariaLabel="Mention suggestions" className="t-w-80">
    {popup.items.map((item, index) => (
      <MentionOption
        key={item.id}
        item={item}
        isHighlighted={index === popup.highlightedIndex}
        onSelect={popup.onSelect}
        onHighlight={popup.onHighlight}
      />
    ))}
  </SuggestionListbox>
);
